import React from "react";
import mapboxgl from "mapbox-gl";
import { Header, Icon, Popup } from 'semantic-ui-react';
import chevronDown from "../assets/chevron-down.png";
import "../styles/Map.css";

// import { processData } from '../data/zipcodes';
// processData();

const moreInfo = {
  valuation: {
    title: "Valuation",
    message: "The Valuation is derived from the average Zillow Home-Value Index (ZHVI) for New York neighborhoods in the past year (2019).",
    meta: "This is not an appraisal, and should only be used as a reference."
  },
  appreciation: {
    title: "Appreciation",
    message: "The appreciation is derived from the growth in Zillow Home-Value Index (ZHVI)  valuation over the past 4 years.",
    meta: "This is not a foolproof indicator of future appreciation, and should only be used as a reference."
  }
};

const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoibWtvbmcwMjE2IiwiYSI6ImNrN3o3M2IzaTAyZHoza3NjaXNmdnhlMmgifQ.1rHWgUCfPgA0IqhLVMJ3DQ";
mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;

const getMapKeyColors = (type) => {
  return type === 'valuation'
    ? [
        { opacity: 1.0 },
        { opacity: 0.9 },
        { opacity: 0.8 },
        { opacity: 0.6 },
        { opacity: 0.4 },
        { opacity: 0.2 }
    ] : [
      { opacity: 1.0 },
      { opacity: 0.75 },
      { opacity: 0.65 },
      { opacity: 0.55 },
      { opacity: 0.4 },
      { opacity: 0.2 },
      { backgroundColor: "#787878", opacity: 0.2 },
      { backgroundColor: "#787878", opacity: 0.4 },
      { backgroundColor: "#787878", opacity: 0.6 }
    ];
};

class Map extends React.Component {
  constructor(props) {
    super(props);

    const url = window.location.href;
    const splitUrl = url.split("?");

    let searchParams = {};
    if (splitUrl.length > 1) {
      searchParams = splitUrl[1].split("&").reduce((params, item) => {
        const [key, value] = item.split("=");
        params[key] = value === "true";
        return params;
      }, {});
    }

    this.state = {
      lng: -73.9899,
      lat: 40.7525,
      zoom: 14,
      showAppreciation: searchParams.appreciation || false,
      showValuation: searchParams.valuation || false,
      showStoreMenu: false,
      showApprMenu: false,
      constructionFilter: false,
      storeFilters: {
        Cafe: false,
        Groceries: false,
        Nightlife: false,
      },
      showMoreInfo: false
    };

    this.mapContainer = React.createRef();
  }

  componentDidMount() {
    this.Map = new mapboxgl.Map({
      container: this.mapContainer.current,
      style: "mapbox://styles/mkong0216/ck9250spp1u8g1ipjb9ysg063",
      center: [this.state.lng, this.state.lat],
      zoom: this.state.zoom,
    });

    this.Map.on("move", () => {
      this.setState({
        lng: this.Map.getCenter().lng.toFixed(4),
        lat: this.Map.getCenter().lat.toFixed(4),
        zoom: this.Map.getZoom().toFixed(2),
      });
    });
    this.Map.on("load", this.addHeatmapLayer);
    this.Map.on("load", this.addPOILayers);
    this.Map.on("styleimagemissing", (event) => console.log(event));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.storeFilters !== this.state.storeFilters) {
      this.togglePOILayers();
    }

    if (prevState.showAppreciation !== this.state.showAppreciation ||
        prevState.showValuation !== this.state.showValuation) {
      this.toggleApprLayers();
    }

    if (prevState.constructionFilter !== this.state.constructionFilter) {
      const visibility = this.Map.getLayoutProperty(
        "construction",
        "visibility"
      );
      const updateVisibility = this.state.constructionFilter
        ? "visible"
        : "none";

      if (visibility !== updateVisibility) {
        this.Map.setLayoutProperty('construction', 'visibility', updateVisibility);
      }
    }
  }

  toggleMoreInfoModal = () => this.setState({ showMoreInfo: !this.state.showMoreInfo });

  togglePOILayers = () => {
    const POILayers = [
      { layer: "stores-cafe", id: "Cafe" },
      { layer: "stores-groceries", id: "Groceries" },
    ];

    const { storeFilters } = this.state;

    POILayers.forEach(({ layer, id }) => {
      const visiblity = this.Map.getLayoutProperty(layer, "visibility");
      const updateVisibility = storeFilters[id] ? "visible" : "none";
      if (visiblity !== updateVisibility) {
        this.Map.setLayoutProperty(layer, "visibility", updateVisibility);
      }
    });
  };

  toggleApprLayers = () => {
    const ApprPOILayers = [
      { layer: "valuation", id: "showValuation" },
      { layer: "appreciation", id: "showAppreciation" },
      { layer: "appreciation-rank", id: "showAppreciation" },
      { layer: "valuation-rank", id: "showValuation"}
    ];

    ApprPOILayers.forEach(({ layer, id }) => {
      const visiblity = this.Map.getLayoutProperty(layer, "visibility");
      const updateVisibility = this.state[id] ? "visible" : "none";
      if (visiblity !== updateVisibility) {
        this.Map.setLayoutProperty(layer, "visibility", updateVisibility);
      }
    });
  };

  toggleStoreMenu = () => {
    this.setState({
      showStoreMenu: !this.state.showStoreMenu,
    });
  };

  toggleStoreFilter = (filter) => {
    const updatedFilterValue = !this.state.storeFilters[filter];
    this.setState({
      storeFilters: {
        ...this.state.storeFilters,
        [filter]: updatedFilterValue,
      },
      constructionFilter: false,
    });
  };

  toggleHeatmapFilters = (key) => {
    const updatedState = {
      [key]: !this.state[key]
    };
    
    if (updatedState[key]) {
      const otherFilter = key === "showValuation" ? "showAppreciation" : "showValuation";
      updatedState[otherFilter] = false;
    }

    this.setState(updatedState);
  }

  toggleConstructionFilter = () => {
    const updatedState = {
      constructionFilter: !this.state.constructionFilter,
    };

    const visible = updatedState.constructionFilter ? "visible" : "none";

    if (updatedState.constructionFilter) {
      updatedState.showStoreMenu = false;
      updatedState.storeFilters = {
        Cafe: false,
        Groceries: false,
        Nightlife: false,
      };
    }

    this.setState({ ...updatedState });
    this.Map.setLayoutProperty("construction", "visibility", visible);
  };

  addPOILayers = () => {
    this.Map.addSource("places", {
      type: "geojson",
      data: require("../data/places.geojson"),
    });

    this.Map.addSource("construction", {
      type: "geojson",
      data: require("../data/constructions.geojson"),
    });

    this.Map.addLayer({
      id: "stores-cafe",
      type: "symbol",
      source: "places",
      minZoom: 14,
      filter: ["==", "category", 0],
      layout: {
        "icon-image": "cafe",
        "icon-size": 1.0,
        visibility: "none",
      },
    });

    this.Map.addLayer({
      id: "stores-groceries",
      type: "symbol",
      minZoom: 14,
      source: "places",
      filter: ["==", "category", 1],
      layout: {
        "icon-image": "opened-store",
        "icon-size": 1.0,
        visibility: "none",
      },
    });

    this.Map.addLayer({
      id: "construction",
      type: "symbol",
      source: "construction",
      minZoom: 14,
      layout: {
        "icon-image": [
          "match",
          ["get", "status"],
          ["closed"],
          "closed-construction",
          // "cafe",
          ["opened"],
          "construction",
          // "opened-store",
          "mapbox-logo",
        ],
        // "icon-image": "mapbox-logo",
        "icon-size": 1.0,
        visibility: "none",
      },
    });

    this.showPopup();
  };

  showPopup = () => {
    this.Map.on("click", "appreciation", (e) => {
      const coordinates = [
        e.features[0].properties.longitude,
        e.features[0].properties.latitude,
      ];
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      const locationLabel = `${e.features[0].properties.PO_NAME}, ${e.features[0].properties.STATE}, ${e.features[0].properties.postalCode}`;
      const appreciationValue = e.features[0].properties.appreciation - 1.00;
      const positive = appreciationValue > 0;
      const appreciationRank = e.features[0].properties.appreciation_rank;
  
      const popup = `
        <div>
          ${appreciationRank <= 5 ? `
            <div class="rank">
              <span><b>Ranked #${appreciationRank} neighborhood in NYC</b></span>
              <span class="meta">Based on appreciation rate</span>
            </div>
          ` : ""
          }
          <div>
            ${locationLabel}<br/>
            Appreciation: ${positive ? "+" : ""}${appreciationValue.toLocaleString("en-US", {style: "percent", maximumSignificantDigits: 3})}
          </div>
        </div>
      `;
      new mapboxgl.Popup({ closeOnClick: true, closeOnMove: true })
        .setLngLat(coordinates)
        .setHTML(popup.toString())
        .addTo(this.Map);
    });

    this.Map.on("click", "valuation", (e) => {
      const coordinates = [
        e.features[0].properties.longitude,
        e.features[0].properties.latitude,
      ];
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      
      const valuationRank = e.features[0].properties.valuation_rank;

      const locationLabel = `${e.features[0].properties.PO_NAME}, ${e.features[0].properties.STATE}, ${e.features[0].properties.postalCode}`;
      const popup = `
        <div>
          ${valuationRank <= 5 ? `
            <div class="rank">
              <span><b>Ranked #${valuationRank} neighborhood in NYC</b></span>
              <span class="meta">Based on current valuation</span>
            </div>
          ` : ""
          }
          <div>
            ${locationLabel}<br/>
            Valuation: ${e.features[0].properties.valuation.toLocaleString(
              "en-US",
              { style: "currency", currency: "USD" }
            )}
          </div>
        </div>
      `;
      new mapboxgl.Popup({ closeOnClick: true, closeOnMove: true })
        .setLngLat(coordinates)
        .setHTML(popup.toString())
        .addTo(this.Map);
    });

    // When a click event occurs on a feature in the places layer, open a popup at the
    // location of the feature, with description HTML from its properties.
    this.Map.on("click", "construction", (e) => {
      const coordinates = e.features[0].geometry.coordinates.slice();
      // Ensure that if the map is zoomed out such that multiple
      // copies of the feature are visible, the popup appears
      // over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      const popup = e.features[0].properties.issued
        ? `
        <div>
          <div>
            ${e.features[0].properties.name}<br/>
            ${e.features[0].properties.label}
          </div>
          <div class="meta">${e.features[0].properties.issued}</div>
          <div class="license">
            License Issued
            <div class="check" />
          </div>
        </div>
      `
        : `
        <div>
          <div>
            ${e.features[0].properties.name}<br/>
            ${e.features[0].properties.label}
          </div>
        </div>
      `;

      new mapboxgl.Popup({ closeOnClick: true, closeOnMove: true })
        .setLngLat(coordinates)
        .setHTML(popup.toString())
        .addTo(this.Map);
    });

    // Change the cursor to a pointer when the mouse is over the places layer.
    this.Map.on("mouseenter", "construction", () => {
      this.Map.getCanvas().style.cursor = "pointer";
    });

    // Change it back to a pointer when it leaves.
    this.Map.on("mouseleave", "construction", () => {
      this.Map.getCanvas().style.cursor = "";
    });
  };

  // Example of heatmap
  addHeatmapLayer = () => {
    this.Map.addSource("neighborhoods", {
      type: "geojson",
      data: require("../data/zipcodes_final.geojson"),
    });

    this.Map.addSource("centers", {
      type: "geojson",
      data: require("../data/zipcodes_centers.geojson"),
    });

    const showAppreciation = this.state.showAppreciation ? "visible" : "none";
    const showValuation = this.state.showValuation ? "visible" : "none";

    this.Map.addLayer({
      id: "valuation",
      type: "fill",
      source: "neighborhoods",
      filter: ["!=", ["get", "valuation"], null],
      layout: {
        visibility: showValuation,
      },
      paint: {
        "fill-color": "#246CF6",
        "fill-outline-color": "#fff",
        "fill-opacity": [
          "step",
          ["abs", ["get", "valuation"]],
          0.2,
          500000, 0.4,
          750000, 0.6,
          1000000, 0.8,
          2000000,0.9,
          3000000, 1.0
        ],
      },
    });

    this.Map.addLayer({
      id: "appreciation",
      type: "fill",
      source: "neighborhoods",
      layout: {
        visibility: showAppreciation,
      },
      filter: ["!=", ["get", "appreciation"], null],
      paint: {
        "fill-color": [
          "case",
          [">=", ["get", "appreciation"], 1.0],
          "#2ED47A",
          ["<", ["get", "appreciation"], 1.0],
          "#787878",
          "#787878",
        ],
        "fill-outline-color": "#fff",
        "fill-opacity": [
          "step",
          ["-", ["get", "appreciation"], 1.0],
          0.6,
          -0.02, 0.4,
          -0.01, 0.2,
          0.02, 0.2,
          0.04, 0.4,
          0.06, 0.55,
          0.07, 0.65,
          0.08, 0.75,
          0.1, 1.0,
        ],
      },
    });

    this.Map.addLayer({
      id: "appreciation-rank",
      type: "symbol",
      source: "centers",
      filter: [
        "all",
        ["<=", ["get", "appreciation_rank"], 5],
        ["!=", ["get", "appreciation"], null],
      ],
      layout: {
        "text-field": ["get", "appreciation_rank"],
        visibility: showAppreciation,
      },
    });

    this.Map.addLayer({
      id: "valuation-rank",
      type: "symbol",
      source: "centers",
      filter: [
        "all",
        ["<=", ["get", "valuation_rank"], 5],
        ["!=", ["get", "valuation"], null],
      ],
      layout: {
        "text-field": ["get", "valuation_rank"],
        visibility: showValuation,
      },
    });
  };

  toggleAppreciationFilters = () => {
    this.setState({
      showAppreciation: !this.state.showAppreciation,
      showValuation: !this.state.showValuation,
    });
  };

  render() {
    const { showStoreMenu, storeFilters, showAppreciation, showValuation, showMoreInfo } = this.state;

    const heatmapType = showValuation ? "valuation" : "appreciation";
    const mapKeyColors = getMapKeyColors(heatmapType);

    return (
      <div>
        <ul className="mapFilters">
          <li className={`valuation ${showValuation ? "menu-opened" : ""}`} onClick={() => this.toggleHeatmapFilters("showValuation")}>Valuation</li>
          <li className={`appreciation ${showAppreciation ? "menu-opened" : ""}`} onClick={() => this.toggleHeatmapFilters("showAppreciation")}>Appreciation</li>
          <li>School</li>
          <div>
            <li className="stores" onClick={this.toggleStoreMenu}>
              Stores
              <img src={chevronDown} alt="Stores" className="chevron-down" />
            </li>
            {showStoreMenu && (
              <div className="store-filters">
                {Object.keys(storeFilters).map((filter, i) => {
                  const filterToggled = storeFilters[filter];
                  const toggledStyle = {
                    backgroundColor: "#246CF6",
                    borderColor: "#246CF6",
                  };

                  return (
                    <div
                      className="store-filter-item"
                      key={i}
                      onClick={() => this.toggleStoreFilter(filter)}
                    >
                      <div
                        className="radio-button"
                        style={filterToggled ? toggledStyle : {}}
                      />
                      {filter}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {/* <li onClick={this.toggleConstructionFilter}>Construction Licenses</li> */}
        </ul>
        {(showAppreciation || showValuation) && (
          <div className="mapKey">
            <div style={{ flexDirection: "row", display: "flex" }}>
              <div className="mapKeyBar">
                {mapKeyColors.map((style, i) => (
                  <div
                    key={i}
                    className={heatmapType === "valuation" ? "valuation-key" : "appreciation-key"}
                    style={style}
                  />
                ))}
              </div>
              <div className="mapKeyLabels">
                <span>{showAppreciation ? "High Positive" : "$3 Mil."}</span>
                <span>{showAppreciation ? "Low Negative" : "$700k"}</span>
              </div>
            </div>
            <Popup
              className="info-popup"
              open={showMoreInfo}
              trigger={<Icon name="question circle outline" className="help" size="large" onClick={this.toggleMoreInfoModal} />}
              header={(
                <Header style={{ padding: 10, paddingTop: 5, paddingRight: 0 }} as="h3" dividing>
                  {moreInfo[heatmapType].title}
                  <Icon name="close" size="tiny" link className="close-button" onClick={this.toggleMoreInfoModal} />
                </Header>
              )}
              content={(
                <div style={{ display: "flex", flexDirection: "column", padding: 10, paddingTop: 0, paddingBottom: 0 }}>
                  <span>
                    {moreInfo[heatmapType].message}
                    <a href="/">{" "}Learn more.</a>
                  </span>
                  <span style={{ marginTop: 10, color: "grey" }}>{moreInfo[heatmapType].meta}</span>
                </div>
              )}
              basic
              wide
              position="bottom left"
            />
          </div>
        )}
        <div className="mapContainer" ref={this.mapContainer} />
        {/* <InfoModal open={showMoreInfo} handleClose={this.toggleMoreInfoModal} /> */}
      </div>
    );
  }
}

export default Map;
